import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import '@/styles/pdf-viewer.css';
import { useElementSize } from '@mantine/hooks';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { File } from 'react-pdf/dist/shared/types.js';

type PdfViewerTypes = {
    file?: File;
};

// pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PdfViewer: React.FC<PdfViewerTypes> = ({ file }) => {
    const [numPages, setNumPages] = useState<number>();

    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }

    const { ref, width } = useElementSize();

    return (
        <div ref={ref} className="flex-1 flex basis-0 overflow-y-auto h-full relative w-full">
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.from(new Array(numPages), (el, index) => (
                    <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        width={width}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                    />
                ))}
            </Document>
        </div>
    );
};
